module.exports = __webpack_public_path__ + "img/loading.d4c6dd52.gif";